import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './components/home/Home';
import ProductDetail from './components/home/ProductDetail';
import CartPage from './components/cart/CartPage';
import Checkout from './components/cart/Checkout';


import api from './services/api';

import SearchPage from './components/search/SearchPage';
import ShowroomPage from './components/showroom/ShowroomPage';
import ContactPage from './components/contact/ContactPage';
import AuthPage from './components/auth/AuthPage';
import CategoriesPage from './components/categories/CategoriesPage';
import CategoryDetailsPage from './components/categories/CategoryDetailsPage';
import FavoritesPage from './components/favorites/FavoritesPage';
import ScrollToTop from './components/common/ScrollToTop';
import FloatingFavorites from './components/layout/FloatingFavorites';

// Admin Components
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminInventory from './components/admin/AdminInventory';
import AdminOrders from './components/admin/AdminOrders';
import AdminReports from './components/admin/AdminReports';
import AdminUsers from './components/admin/AdminUsers';

import ProtectedRoute from './components/common/ProtectedRoute';

import { CartProvider } from './context/CartContext';
import { UserProvider } from './context/UserContext';
import { FavoritesProvider } from './context/FavoritesContext';
import './App.css';

// Wrapper for conditional Navbar/Footer
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {!isAdmin && <Navbar />}
      <main>
        {children}
      </main>
      {!isAdmin && <FloatingFavorites />}
      {!isAdmin && <Footer />}
    </div>
  );
};


function App() {
  React.useEffect(() => {
    if (!sessionStorage.getItem('showroom_visited')) {
      api.post('/api/stats/visit/').catch(err => console.error('Error tracking visit:', err));
      sessionStorage.setItem('showroom_visited', 'true');
    }
  }, []);

  return (
    <Router>
      <UserProvider>
        <CartProvider>
          <FavoritesProvider>
            <ScrollToTop />
            <AppLayout>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<Checkout />} />

                <Route path="/search" element={<SearchPage />} />
                <Route path="/showroom" element={<ShowroomPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/category/:categoryName" element={<CategoryDetailsPage />} />
                <Route path="/favorites" element={<FavoritesPage />} />

                {/* Admin Routes */}
                <Route path="/admin" element={
                  <ProtectedRoute adminOnly>
                    <AdminLayout />
                  </ProtectedRoute>
                }>
                  <Route index element={<AdminDashboard />} />
                  <Route path="inventory" element={<AdminInventory />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="reports" element={<AdminReports />} />
                </Route>
              </Routes>
            </AppLayout>
          </FavoritesProvider>
        </CartProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
